<template>
    <div id="porizontalpillar" :style="{ height: '100%'}"></div>
</template>
<script >
import { cmsSysCloudlsdCountCommodityType } from '../../../../api/home.js'
export default {
    name: "",
    components: {},
    props: ['intervalRefreshDate'],
    data() {
        return {
            timer: null,
            yData: [
                // '护肤品类',
                // '营养品类',
                // '日用品类',
                // '酒水饮料',
                // '宠物用品',
                // '进口零食',
                // '米酒粮面',
                // '调味用品',
                // '运动类型',
                // '其他品类',
            ],
            eData: []
        };
    },

    watch: {},
    computed: {},
    methods: {
        async init() {
            try {
                const res = await cmsSysCloudlsdCountCommodityType()
                const yData = [], eData = []
                res.data.forEach((item, index) => {
                    const { commodityTypeName, commodityTypeAmount } = item
                    yData.push(commodityTypeName)
                    eData.push(commodityTypeAmount)

                });
                this.yData = yData;
                this.eData = eData;

            } catch (err) {
                this.$message.error("数据加载失败")
            }

        },
        drawLine() {
            // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
            let myChart = this.$echarts.init(document.getElementById('porizontalpillar'))
            // 绘制图表
            this.eData.sort((a, b) => b - a);
            var max = Math.max.apply(null, this.eData);
            var getMax = [];
            for (let i = 0; i < this.yData.length; i++) {
                getMax.push(max);
            }
            const option = {
                // backgroundColor: '#0b1751',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                    },
                    formatter: function (params) {
                        return params[0].name + ' : ' + params[0].value;
                    },
                },
                xAxis: {
                    show: false,
                    type: 'value',
                },
                grid: {
                    right: '1%',
                    left: '9%',
                    top: '4%',
                    bottom: '1%',
                    containLabel: true,
                },
                yAxis: [
                    {
                        type: 'category',
                        inverse: true,
                        offset: 120,
                        axisLabel: {
                            show: true,
                            align: 'left',
                            textStyle: {
                                color: '#fff',
                                fontSize: '14',
                            },
                            formatter: function (value, index) {
                                var num = '';
                                var str = '';
                                num = index + 1;
                                if (index === 0) {
                                    str = '{no1|' + '} {num1|' + num + '} {title1| ' + value + '}';
                                } else if (index === 1) {
                                    str = '{no2|' + '} {num2|' + num + '} {title2| ' + value + '}';
                                } else if (index === 2) {
                                    str = '{no3|' + '} {num3|' + num + '} {title3| ' + value + '}';
                                } else {
                                    str = ' {num|' + num + '} {title| ' + value + '}';
                                }
                                return str;
                            },
                            rich: {

                                num: {
                                    color: '#fff',
                                    backgroundColor: '#5090f7',
                                    width: 10,
                                    height: 10,
                                    fontSize: 14,
                                    padding: [6, 5, 3, 5],
                                    align: 'center',
                                    shadowColor: '#3374ba',
                                    borderColor: '#3374ba',
                                    borderWidth: 1,
                                },
                                num1: {
                                    color: '#fff',
                                    backgroundColor: 'red',
                                    width: 10,
                                    height: 10,
                                    fontSize: 14,
                                    padding: [7, 5, 3, 5],
                                    align: 'center',
                                    shadowColor: 'red',
                                    borderColor: 'red',
                                    borderWidth: 1,
                                },
                                num2: {
                                    color: '#fff',
                                    backgroundColor: '#f29c38',
                                    width: 10,
                                    height: 10,
                                    fontSize: 14,
                                    padding: [7, 5, 3, 5],
                                    align: 'center',
                                    shadowColor: '#f29c38',
                                    borderColor: '#f29c38',
                                    borderWidth: 1,
                                },
                                num3: {
                                    color: '#fff',
                                    backgroundColor: '#f9d247',
                                    width: 10,
                                    height: 10,
                                    fontSize: 14,
                                    padding: [7, 5, 3, 5],
                                    align: 'center',
                                    shadowColor: '#f9d247',
                                    borderColor: '#f9d247',
                                    borderWidth: 1,
                                },
                            },
                        },
                        splitLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        data: this.yData,
                    },
                    {
                        type: 'category',
                        inverse: true,
                        offset: 0,
                        axisTick: 'none',
                        axisLine: 'none',
                        show: true,
                        axisLabel: {
                            textStyle: {
                                color: '#fff',
                                fontSize: '14',
                            },
                        },
                        data: this.eData,
                    },
                ],
                series: [
                    {
                        name: '值',
                        type: 'bar',
                        offset: 0,
                        zlevel: 1,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 30,
                                label: {
                                    show: false, //开启显示
                                    position: "right",
                                    // offset: -45,
                                
                                    textStyle: { //数值样式
                                        color: '#fff',
                                        fontSize: 12
                                    }

                                },
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 1,
                                    y2: 0,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#5093f7', //  0%  处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#59c9fa', //  100%  处的颜色
                                        },
                                    ],
                                    global: false, //  缺省为  false
                                },
                            },
                        },
                        barWidth: 10,
                        data: this.eData,
                    },
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 10,
                        barGap: '-100%',
                        data: getMax,
                        itemStyle: {
                            color: '#0f2a65',
                            barBorderRadius: 30,
                        },
                    },
                ],
            };






            myChart.clear();
            myChart.setOption(option);
        }
    },
    created() { },
    async mounted() {
        await this.init()
        this.drawLine();
        this.timer = setInterval(async () => {
            await this.init()
            this.drawLine();
        }, 
        // this.$intervalRefreshDate
        this.intervalRefreshDate
        )
    },
    beforeDestroy() {
        console.log("销毁定时器")
        //2.销毁前清除定时器
        clearInterval(this.timer);
    },
    
}
</script>
<style lang="scss" scoped>

</style>